import { createNode } from '@glueapp/graph-types';
import { GmailIntegration } from './GmailIntegration';

export const GMailGetEmailsInInbox = createNode({
    id: 'Gmail Get Emails in Inbox',
    name: 'Gmail Get Emails in Inbox',
    description: 'Get all the emails in your inbox',
    aiDescription:
        'Requires the Google Mail integration to be connected. Takes an optional "Search" (string) input port for filtering inbox emails using Gmail search syntax. Outputs an "Emails" port containing an array of objects with "id" and "threadId" properties. Results are limited to the inbox label.',
    category: 'Google Mail',
    color: '#ee4237',
    integration: GmailIntegration,
    inPorts: {
        Search: {
            kind: 'string',
        },
    },
    outPorts: {
        Emails: {
            kind: 'array',
            subType: {
                kind: 'object',
                properties: {
                    id: { kind: 'string' },
                    threadId: { kind: 'string' },
                },
                restriction: 'exact',
            },
        },
    },
    isAsync: true,
    execute: async function (input) {
        try {
            const searchQuery = input.inPorts.Search?.trim();
            let params = {
                q: searchQuery ? `label:inbox ${searchQuery}` : 'label:inbox',
                maxResults: 500,
            };
            const response = await input.integration.callIntegration<{ messages: { id: string; threadId: string }[] }>({
                url: 'https://gmail.googleapis.com/gmail/v1/users/me/messages',
                params,
            });
            return { output: { Emails: response.data.messages ?? [] } };
        } catch {
            return { output: { Emails: [] } };
        }
    },
});
